import * as React from 'react';

import classNames from 'classnames';

import { IIconProps } from './types';

import * as s from './Icon.scss';

export const Icon = (props: IIconProps) => {
	const { className, classNameSvg, glyph, onClick, title, ...restProps } = props;

	return (
		<span className={classNames(s.block, className)} onClick={onClick} title={title}>
			<svg className={classNames(s.svg, classNameSvg)} {...restProps}>
				<use xlinkHref={`#${glyph.id}`} />
			</svg>
		</span>
	);
};
